import { jsxs as l, jsx as t, Fragment as V } from "react/jsx-runtime";
import { Form as n, Input as z } from "antd";
import { useState as C, useEffect as U } from "react";
import { R as j } from "../../../../DeleteOutlined-BpfKCRGu.js";
const { Item: k } = n, S = ({
  type: r,
  formItemProps: c,
  getVideoId: f,
  getEmbedVideoUrl: g,
  getVideoUrl: h,
  exampleUrl: v,
  iframeProps: b
}) => {
  const [u, m] = C(""), o = n.useFormInstance(), { name: a } = c, e = n.useWatch(a, o), p = r.toUpperCase();
  if (U(() => {
    if (e != null && e.id) {
      const i = h(e.id, u);
      m(i);
    }
  }, [e == null ? void 0 : e.id]), !a)
    throw new Error("name is required");
  const d = e == null ? void 0 : e.id, x = e && d, w = e && !d, I = g(d), N = () => {
    o.setFieldValue(a, {
      type: r,
      id: "",
      meta: {}
    });
  };
  return /* @__PURE__ */ l("div", { className: "at-relative [&_*]:at-box-border", children: [
    /* @__PURE__ */ t(
      z,
      {
        size: "small",
        allowClear: !0,
        placeholder: `請輸入 ${p} 影片連結`,
        value: u,
        onChange: (i) => {
          const s = i.target.value;
          m(s);
          const y = s ? f(s) : "";
          o.setFieldValue(a, {
            type: r,
            id: y,
            meta: {}
          });
        },
        className: "at-mb-1"
      }
    ),
    /* @__PURE__ */ t(k, { ...c, hidden: !0 }),
    x && /* @__PURE__ */ t(V, { children: /* @__PURE__ */ t(
      "div",
      {
        className: "at-aspect-video at-w-full at-p-2",
        style: {
          border: "1px dashed #d9d9d9",
          backgroundColor: "rgba(0, 0, 0, 0.02)",
          borderRadius: "8px"
        },
        children: /* @__PURE__ */ t("div", { className: "at-size-full at-rounded-xl at-overflow-hidden", children: /* @__PURE__ */ l(
          "div",
          {
            className: `at-rounded-xl at-bg-gray-200 ${e ? "at-tw-block" : "at-tw-hidden"}`,
            style: {
              position: "relative",
              paddingTop: "56.25%"
            },
            children: [
              /* @__PURE__ */ t(
                "iframe",
                {
                  className: "at-border-0 at-absolute at-top-0 at-left-0 at-size-full at-rounded-xl",
                  src: I,
                  loading: "lazy",
                  frameBorder: "0",
                  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                  referrerPolicy: "strict-origin-when-cross-origin",
                  allowFullScreen: !0,
                  ...b
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  onClick: N,
                  className: "at-group at-absolute at-top-4 at-right-4 at-rounded-md at-size-12 at-bg-white at-shadow-lg at-flex at-justify-center at-items-center at-transition at-duration-300 hover:at-bg-red-500 at-cursor-pointer",
                  children: /* @__PURE__ */ t(j, { className: "at-text-red-500 group-hover:at-text-white" })
                }
              )
            ]
          }
        ) })
      }
    ) }),
    w && /* @__PURE__ */ l("div", { children: [
      "請輸入有效的 ",
      p,
      " 影片連結 例如:",
      v
    ] })
  ] });
};
export {
  S as default
};
